import React, { Component } from "react";
import { Checkbox } from ".";
import Fade from '@kogk/react-reveal/Fade';

export default class Card extends Component {
  static defaultProps = {
    selected: false,
    wide: false
  };

  render() {
    const {
      photo,
      title,
      description,
      wide,
      selected,
      readOnly,
      ...props
    } = this.props;

    const Element = readOnly ? 'div' : 'label';

    return (
      <Fade>
        <Element
          className={[
            "card",
            wide ? "card--wide" : "",
            selected ? "card--selected" : "",
            "text-white"
          ].join(" ")}
          style={{
            backgroundImage: `url(${photo || "/images/placeholder.png"})`
          }}
        >
          <div className="card__ratio">
            <div className="flex flex-col justify-between p-3 md:p-4 lg:p-5 absolute-fill">
              <div className="w-full text-right">
                { !readOnly ? <Checkbox {...props} checked={selected} theme="light" /> : null }
              </div>
              <div className="card__content first:mt-0 last:mb-0">
                <h4 className="h5 mb-1">{title}</h4>
                <p className="text-xs md:text-sm lg:text-base mt-0">{description}</p>
              </div>
            </div>
          </div>
        </Element>
      </Fade>
    );
  }
}
